import axios from 'axios'
export default() => {
    const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://adve.pro/api';
    
    return axios.create({
        baseURL: baseURL,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': localStorage.getItem("hope") || ''
        }
    })
}
 